export type MivoTranslationKey = "pt-BR" | "en" | "es" | "de";

/** Required on all translation objects; `de` is optional until quad-locale migration completes. */
export type MivoTranslationRequiredKey = "pt-BR" | "en" | "es";

export type MivoTranslationType = Record<MivoTranslationRequiredKey, string> & Partial<Record<"de", string>>;

export type MivoTranslationValue<T extends MivoTranslationType> = string;

export const MIVO_LOCALES: readonly MivoTranslationKey[] = ["pt-BR", "en", "es", "de"];

export const MIVO_REQUIRED_TRANSLATION_KEYS: readonly MivoTranslationRequiredKey[] = ["pt-BR", "en", "es"];

export const DEFAULT_MIVO_LOCALE: MivoTranslationKey = "pt-BR";

export const LOCALE_STORAGE_KEY = "mivo.locale";

/** @deprecated Short chrome labels superseded by {@link LOCALE_NATIVE_LABELS}. */
export const LOCALE_SWITCHER_LABELS: Record<MivoTranslationKey, string> = {
  "pt-BR": "PT",
  en: "EN",
  es: "ES",
  de: "DE",
};

/** Native language names for chrome/settings menus — never localized. */
export const LOCALE_NATIVE_LABELS: Record<MivoTranslationKey, string> = {
  "pt-BR": "Português",
  en: "English",
  es: "Español",
  de: "Deutsch",
};

/** Localized popover / section title and trigger accessible name. */
export const LANGUAGE_SWITCHER_TITLE = {
  "pt-BR": "Idioma",
  en: "Language",
  es: "Idioma",
  de: "Sprache",
} as const;
